<template>
<el-container>
  <div class="msg-right-all" v-if="!ismobile">
    <el-skeleton animated :loading="hotelShow">
      <template slot="template">
        <div class="msg-right">
          <div style="margin-bottom: 10px; padding: 4.5% 4.5% 0 4.5%;">
            <!--酒店信息部分-->
            <div>
              <div style="font-size:18px; font-weight:650;padding-bottom: 15px;">
                <span v-if="language === 'zh'">
                  <el-skeleton-item variant="text"/><el-skeleton-item variant="text"/>
                </span>
                <span v-else><el-skeleton-item variant="text"/></span>
              </div>
              <div><el-skeleton-item variant="text"/></div>
            </div>
            <div style="font-size:16px; font-weight:650;text-align:right;"><el-skeleton-item variant="text" style="width: 10%;"/></div>
          </div>
          <div role="progressbar" style="padding-right: 4.5%;" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
            <div class="score-bar">
              <div class="scoreNo" style="height: 6px;">
                <div class="scoreYes"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div class="msg-right" style="width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;">
          <div style="margin-bottom: 10px; padding: 4.5% 4.5% 0 4.5%;">
            <!--酒店信息部分-->
            <div>
              <div style="font-size:18px; font-weight:650;padding-bottom: 15px;">
                <span v-if="language === 'zh'">{{hotel.hotelname_zh}}<br>({{hotel.hotelname_en}}）</span>
                <span v-else>{{hotel.hotelname_en}}</span>
              </div>
              <div style="display:inline-block;width:5%;vertical-align: top;"><i class="el-icon-location"></i></div>
              <div style="display:inline-block;font-size:12px; color:#797979;width:90%;">
                <span v-if="language === 'zh'"><a v-if="hotel.hoteladdress_zh !== ''">{{hotel.hoteladdress_zh}}</a><a v-else>{{hotel.hoteladdress_en}}</a></span>
                <span v-else>{{hotel.hoteladdress_en}}</span>
              </div>
            </div>
            <div style="font-size:16px; font-weight:650;text-align:right;">{{hotel.hotelscore}}</div>
          </div>
          <div role="progressbar" style="padding-right: 4.5%;" :aria-valuenow="hotel.hotelscore" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
            <div class="score-bar">
              <div class="scoreNo" style="height: 6px;">
                <div class="scoreYes" :style="hotel.hotelscoreRate">
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>
    <!--预定信息-->
    <el-skeleton animated :loading="orderShow">
      <template slot="template">
        <div class="msg-right">
          <div class="advanceText"><el-skeleton-item variant="text" style="height: 29px; margin-top: 13px;width: 80px;"/></div>
          <div class="advanceInfo">
            <div class="margin-top el-descriptions">
              <div class="el-descriptions__body">
                <table class="el-descriptions__table">
                  <tbody>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                        <div class="infotd">
                          <el-skeleton-item variant="text" style="width: 170px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                        <div class="infotd">
                          <el-skeleton-item variant="text" style="width: 170px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                        <div class="infotd">
                          <el-skeleton-item variant="text" style="width: 170px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                          <div class="infotd">
                            <el-skeleton-item variant="text" style="width: 30px;"/>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                          <div class="infotd">
                            <el-skeleton-item variant="text" style="width: 30px;"/>
                          </div>
                      </td>
                    </tr>
                    <tr v-for="index in 4" :key="index">
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                          <div class="infotd">
                            <el-skeleton-item variant="text" style="width: 130px;"/>
                          </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div class="msg-right" style="width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;">
          <div class="advanceText">{{$t('bookingInformation')}}</div>
          <div class="advanceInfo">
            <div class="margin-top el-descriptions">
              <div class="el-descriptions__body">
                <table class="el-descriptions__table">
                  <tbody>
                    <tr>
                      <td colspan="1">
                        <div class="titletd">{{$t('roomName')}}</div>
                        <div class="infotd">
                          <span v-html="getLanguageHtml(orderData.roomName,'roomName')"></span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                          <div class="titletd">{{$t('checkInTime')}}</div>
                          <div class="infotd">
                            <span v-html="getLanguageHtml(orderData.checkin,'checkin')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                          <div class="titletd">{{$t('checkOutTime')}}</div>
                          <div class="infotd">
                            <span v-html="getLanguageHtml(orderData.checkout,'checkout')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd">{{$t('travelDates')}}<span>{{ dateNumComplexStr }}</span></div>
                          <div class="infotd">
                            <span v-html="getLanguageHtml(orderData.night,'night')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd">{{$t('roomNumber')}}<span>{{ roomNumComplexStr }}</span></div>
                          <div class="infotd">
                            <span v-html="getLanguageHtml(orderData.roomNum,'roomNum')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                          <div class="titletd">{{$t('guest')}}</div>
                          <div class="infotd">
                            <span style="display: block;" v-html="getLanguageHtml(orderData.person,'person')"></span>
                            <span style="display: block;" v-html="getLanguageHtml(orderData.child,'child')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                          <div class="titletd">{{$t('bedType')}}</div>
                          <div class="infotd">
                            <span v-html="getLanguageHtml(orderData.bedType,'bedType')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                          <div class="titletd">{{$t('breakfast')}}</div>
                          <div class="infotd" :class="{'greenText': orderData.breakfastCode === true}">
                            <span v-html="getLanguageHtml(orderData.breakfast,'breakfast')"></span>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                          <div class="titletd">{{$t('cancellationPolicy')}}</div>
                          <div class="infotd greenText" :class="{'redText': cancelData === 0}">
                            <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="canceltextZh" placement="top-end" v-if="language === 'zh'">
                              <span>
                                {{orderData.cancel.zh}}
                              </span>
                            </el-tooltip>
                            <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="canceltextEn" placement="top-end" v-else>
                              <span>
                                {{orderData.cancel.en}}<span v-if="orderData.cancel.endate !== ''"><br>{{orderData.cancel.endate}}</span>
                              </span>
                            </el-tooltip>
                          </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>
    <!--价格详情-->
    <el-skeleton animated :loading="orderShow">
      <template slot="template">
        <div class="msg-right">
          <div class="priceText"><el-skeleton-item variant="text" style="height: 29px; margin-top: 13px;width: 80px;"/></div>
          <div class="priceInfo">
            <div style="padding:3% 4.5%;">
              <div class="jianye" style="height:50px;">
                <div style="float:left;">
                  <el-skeleton-item variant="text" style="width: 75px; display: block;"/>
                  <el-skeleton-item variant="text" style="width: 110px; display: block;"/>
                </div>
                <div style="float:right;">
                  <span><el-skeleton-item variant="text" style="width: 75px; display: block;"/></span>
                </div>
              </div>
              <div style="clear:both; height:30px;">
                <div style="float:left; height: 25px;line-height: 25px;">
                  <el-skeleton-item variant="text" style="width: 75px;"/>
                </div>
                <div style="float:right;">
                  <el-skeleton-item variant="text" style="width: 75px;"/>
                </div>
              </div>
            </div>
          </div>
          <div style="clear:both; font-size:16px; font-weight:650; height: 54px; padding: 0px 4.5%; line-height: 54px;">
            <div style="display:inline-block;float:left;"><el-skeleton-item variant="text" style="height: 29px; margin-top: 13px;width: 80px;"/></div>
            <div style="display:inline-block;float:right;"><el-skeleton-item variant="text" style="height: 29px; margin-top: 13px;width: 80px;"/></div>
          </div>
        </div>
      </template>
      <template>
        <div class="msg-right" style="width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;">
          <div class="priceText">{{$t('priceDetails')}}</div>
          <div class="priceInfo">
            <div style="padding:3% 4.5%;">
              <div class="jianye" style="height:50px;" v-if="orderData.roomCount !=='' && orderData.nightCount !== ''">
                <div style="float:left;" v-if="language === 'en'">
                  <span>{{orderData.roomCount}} {{$t('onOurSite')}}<span v-if="orderData.roomCount !=='1'">s</span> x {{orderData.nightCount}} {{$t('night')}}<span v-if="orderData.nightCount !== 1">s</span></span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" v-if="orderData.discount != ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} -{{orderData.discount}}</span>
                </div>
                <div style="float:left;" v-else>
                  <span>{{orderData.roomCount}}{{$t('onOurSite')}} x {{orderData.nightCount}}{{$t('night')}}</span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" style="color: #2f7000" v-if="orderData.discount != ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} -{{orderData.discount}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.fareTotal}}</span>
                </div>
              </div>
              <div style="clear:both; height:30px;" v-if="orderData.tax !== ''">
                <div style="float:left; height: 25px;line-height: 25px;">
                  <span>{{$t('taxesFees')}}</span>
                  <el-popover popper-class="popverText" placement="top-start" width="327" offset="99" trigger="click" v-if="language === 'en'">
                    <div style="font-size:8px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                    <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                  </el-popover>
                  <el-popover popper-class="popverText" placement="top-start" width="327" offset="44" trigger="click" v-else>
                    <div style="font-size:8px;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                    <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                  </el-popover>
                </div>
                <div style="float:right;">
                  <span>{{orderData.tax}}</span>
                </div>
              </div>
              <!-- 交易费 开始 -->
              <div class="price-detail-twoline" v-if="TransactionFeeshow === true && source === 'sec'">
                <div style="float:left; height: 25px;">
                  <span>{{$t('TransactionFee')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.curMark}} <a v-if="orderData.discount != ''">{{discountFeeInfo[paymentOn]['discountTFee']}}</a><a v-else>{{transactionFeeInfo[paymentOn]['TFee']}}</a></span>
                </div>
              </div>
              <!-- 交易费 结束 -->
              <div style="clear:both; height:30px;" v-if="orderData.commission !== ''">
                <div style="float:left; height: 25px;line-height: 25px;">
                  <span>{{$t('commission')}}</span>
                  <el-popover popper-class="popverText" placement="top-start" width="327" offset="99" trigger="click">
                    <div style="font-size:8px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"  v-if="language === 'en'">{{$t('roompaiCommissionNotification')}}</div>
                    <div style="font-size:8px;" v-else>{{$t('roompaiCommissionNotification')}}</div>
                    <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                  </el-popover>
                </div>
                <div style="float:right;">
                  <span>{{orderData.commission}}</span>
                </div>
              </div>
              <!-- payableAtProperty -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.mandatoryFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('mandatoryFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.mandatoryFee}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.mandatoryTax !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('mandatoryTax')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.mandatoryTax}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.resortFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('resortFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.resortFee}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.cityFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('cityTaxFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.cityFee}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.destinationFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('destinationFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.destinationFee}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.serviceFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('serviceFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.serviceFee}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.CleaningFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('cleaningFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.CleaningFee}}</span>
                </div>
              </div>
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.administrativeFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('administrativeFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.administrativeFee}}</span>
                </div>
              </div>
              <!-- 婴儿床费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.cribFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('cribFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.cribFee}}</span>
                </div>
              </div>
              <!-- 维护费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.maintenanceFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('maintenanceFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.maintenanceFee}}</span>
                </div>
              </div>
              <!-- 杂费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.miscellaneousFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('miscellaneousFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.miscellaneousFee}}</span>
                </div>
              </div>
              <!-- 其他费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.otherFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('otherFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.otherFee}}</span>
                </div>
              </div>
              <!-- 套餐费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.packageFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('packageFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.packageFee}}</span>
                </div>
              </div>
              <!-- 宠物卫生费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.petSanitationFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('petSanitationFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.petSanitationFee}}</span>
                </div>
              </div>
              <!-- 加床费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.rollawayFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('rollawayFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.rollawayFee}}</span>
                </div>
              </div>
              <!-- 客房服务费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.roomServiceFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('roomServiceFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.roomServiceFee}}</span>
                </div>
              </div>
              <!-- 附加费 -->
              <div :class="{'price-detail-twoline': payAtHotel === true, 'price-detail-oneline': payAtHotel === false}" v-if="orderData.surchargeFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('surchargeFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.surchargeFee}}</span>
                </div>
              </div>
            </div>
          </div>
          <div style="clear:both; font-size:16px; font-weight:650; height: 27px; padding: 0px 4.5%;">
            <div style="display:inline-block;float:left;">
              <span style="display: block;">{{$t('totalPrice')}}</span>
            </div>
            <div style="display:inline-block;float:right;" v-if="orderData.discount != ''">{{orderData.curMark}} <span v-if="TransactionFeeshow === true && source === 'sec'">{{discountFeeInfo[paymentOn]['discountTotalPrice']}}</span><span v-else>{{orderData.discountTotalPrice}}</span></div>
            <div style="display:inline-block;float:right;" v-else>{{orderData.curMark}} <a v-if="TransactionFeeshow === true && source === 'sec'">{{transactionFeeInfo[paymentOn]['totalPPrice']}}</a><a v-else>{{orderData.totalPrice}}</a></div>
          </div>
          <div style="clear:both; font-size:12px; height: 27px; padding: 0px 4.5%;" v-if="orderData.payAtProperty === '' && orderData.hotelFeesEnText === ''">
            <div style="display:inline-block;float:left;">
              <span style="display: block;" class="avgprice">{{$t('includesTaxesFees')}}</span>
            </div>
          </div>
          <div style="clear: both;font-size: 14px;height: 15px;padding: 0px 4.5%;line-height: 25px;padding-bottom: 20px;" v-if="orderData.payAtProperty !== '' && payAtHotel === true">
            <div style="display:inline-block;float:left;">{{$t('payNow')}}</div>
            <div style="display:inline-block;float:right;" v-if="orderData.discount != ''">{{orderData.curMark}} <span v-if="TransactionFeeshow === true && source === 'sec'">{{discountFeeInfo[paymentOn]['discountPayPrice']}}</span><span v-else>{{orderData.discountPayPrice}}</span></div>
            <div style="display:inline-block;float:right;" v-else>{{orderData.curMark}} <a v-if="TransactionFeeshow === true && source === 'sec'">{{transactionFeeInfo[paymentOn]['payPPrice']}}</a><a v-else>{{orderData.payPrice}}</a></div>
          </div>
          <div style="clear: both;font-size: 14px;height: 15px;padding: 0px 4.5%;line-height: 15px;padding-bottom: 20px;" v-if="orderData.payAtProperty !== '' && payAtHotel === true">
            <div style="display:inline-block;float:left;">{{$t('payableAtProperty')}}</div>
            <div style="display:inline-block;float:right;">{{orderData.payAtProperty}}</div>
          </div>
          <div style="clear: both;font-size: 14px; padding: 0px 4.5%;line-height: 15px;" v-if="source !== 'google' && orderData.payAtProperty === '' && orderData.hotelFeesEnText !== '' && payAtHotel === true">
            <div style="border-top: 2px dashed #ccc;padding-top: 10px;margin: 10px 0px 20px;">
              <div style="display: block;font-size: 12px;font-weight: 340;margin-bottom: 3px;">{{$t('notIncludedInTotal')}}</div>
              <div style="display: block;font-size: 12px;font-weight: 340;">
                {{$t('mandatoryChargeHotelCollected')}}
                <el-popover popper-class="popverText" placement="top" :offset="81" width="327" trigger="click">
                  <div style="font-size: 15px;font-weight: 650;margin-bottom: 20px;">{{$t('mandatoryFee')}}</div>
                  <div style="font-size:8px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                    <p style="font-size:12px;" class="hotelFeesText" v-if="language === 'en'" v-html="orderData.hotelFeesEnText"></p>
                    <p style="font-size:12px;" class="hotelFeesText" v-if="language === 'zh'" v-html="orderData.hotelFeesZhText"></p>
                  </div>
                  <span style="color: #279BF3; text-decoration: unset; cursor: pointer;" slot="reference">{{$t('details')}}</span>
                </el-popover>
              </div>
            </div>
          </div>
          <div v-if="orderData.discount != ''">
            <div class="coupon-info">
              <img src="/static/img/order/u207.png" class="coupon-img">
              <span style="margin-left: 5px">{{$t('couponUselargeMsg')}} {{orderData.curMark}} {{orderData.discount}}{{$t('point')}}</span>
            </div>
            <div style="margin: 8px 0px 10px 0px;font-size:12px;">
              <span class="coupon-text">{{$t('couponUseshortMsg')}} {{orderData.discountCode}}</span>
              <span v-if="nowPageData === 'bookingWriteOrder'">
                （<span style="color: rgb(83, 146, 249); cursor: pointer;" @click="delCoupon" >{{$t('remove')}}</span>）
              </span>
            </div>
          </div>
          <div style="clear: both;font-size: 12px;font-weight: 340;padding: 0px 4.5%;height: 10px;" v-if="orderData.payAtProperty !== ''">
            <div style="display:inline-block;float:left;padding-bottom: 15px;">{{$t('priceDetailMsg')}}</div>
          </div>
        </div>
      </template>
    </el-skeleton>
  </div>

  <div class="msg-right-all" v-else>
    <el-skeleton animated :loading="hotelShow">
      <template slot="template">
        <div class="msg-right" style="margin-top: 10px;">
          <div style="margin-bottom: 10px; padding: 4.5% 4.5% 0 4.5%;">
            <div>
              <div style="font-size:16px; font-weight:650;padding-bottom: 15px;">
                <span v-if="language === 'zh'">
                  <el-skeleton-item variant="text"/><el-skeleton-item variant="text"/>
                </span>
                <span v-else> <el-skeleton-item variant="text"/></span>
              </div>
              <div style="display:inline-block;font-size:12px; color:#797979;width:90%;">
                <el-skeleton-item variant="text"/>
              </div>
            </div>
            <div style="font-size:16px; font-weight:650;text-align:right;"><el-skeleton-item variant="text" style="width: 10%;"/></div>
          </div>
          <div role="progressbar" style="padding-right: 4.5%;" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
            <div class="score-bar">
              <div class="scoreNo" style="height: 6px;">
                <div class="scoreYes">
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template>
          <div class="msg-right" style="margin-top: 10px;width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;">
            <div style="margin-bottom: 10px; padding: 4.5% 4.5% 0 4.5%;">
              <div>
                <div style="font-size:16px; font-weight:650;padding-bottom: 15px;">
                  <span v-if="language === 'zh'">{{hotel.hotelname_zh}}<br>({{hotel.hotelname_en}}）</span>
                  <span v-else>{{hotel.hotelname_en}}</span>
                </div>
                <div style="display:inline-block;width:5%;vertical-align: top;"><i class="el-icon-location"></i></div>
                <div style="display:inline-block;font-size:12px; color:#797979;width:90%;">
                  <span v-if="language === 'zh'"><a v-if="hotel.hoteladdress_zh !== ''">{{hotel.hoteladdress_zh}}</a><a v-else>{{hotel.hoteladdress_en}}</a></span>
                  <span v-else>{{hotel.hoteladdress_en}}</span>
                </div>
              </div>
              <div style="font-size:16px; font-weight:650;text-align:right;">{{hotel.hotelscore}}</div>
            </div>
            <div role="progressbar" style="padding-right: 4.5%;" :aria-valuenow="hotel.hotelscore" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
              <div class="score-bar">
                <div class="scoreNo" style="height: 6px;">
                  <div class="scoreYes" :style="hotel.hotelscoreRate">
                  </div>
                </div>
              </div>
            </div>
          </div>
      </template>
    </el-skeleton>
    <!--预定信息-->
    <el-skeleton animated :loading="orderShow">
      <template slot="template">
        <div class="msg-right">
          <div class="advanceText"><el-skeleton-item variant="text" style="height: 25px; margin-top: 15px;width: 80px;"/></div>
          <div class="advanceInfo">
            <div class="margin-top el-descriptions">
              <div class="el-descriptions__body">
                <table class="el-descriptions__table">
                  <tbody>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                        <div class="infotd">
                          <el-skeleton-item variant="text" style="width: 170px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                        <div class="infotd">
                          <el-skeleton-item variant="text" style="width: 170px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                        <div class="infotd">
                          <el-skeleton-item variant="text" style="width: 170px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                          <div class="infotd">
                            <el-skeleton-item variant="text" style="width: 30px;"/>
                          </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                          <div class="infotd">
                            <el-skeleton-item variant="text" style="width: 30px;"/>
                          </div>
                      </td>
                    </tr>
                    <tr v-for="index in 4" :key="index">
                      <td colspan="1">
                        <div class="titletd"><el-skeleton-item variant="text" style="width: 70px;"/></div>
                          <div class="infotd">
                            <el-skeleton-item variant="text" style="width: 130px;"/>
                          </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div class="msg-right" style="width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;">
          <div class="advanceText">{{$t('bookingInformation')}}</div>
          <div class="advanceInfo">
            <div class="margin-top el-descriptions">
              <div class="el-descriptions__body">
                <table class="el-descriptions__table">
                  <tbody>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('roomName')}}</div>
                      <div class="infotd">
                        <span v-html="getLanguageHtml(orderData.roomName,'roomName')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('checkInTime')}}</div>
                      <div class="infotd">
                        <span v-html="getLanguageHtml(orderData.checkin,'checkin')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('checkOutTime')}}</div>
                      <div class="infotd">
                        <span v-html="getLanguageHtml(orderData.checkout,'checkout')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('travelDates')}}<span>{{ dateNumComplexStr }}</span></div>
                      <div class="infotd">
                        <span v-html="getLanguageHtml(orderData.night,'night')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('roomNumber')}}<span>{{ roomNumComplexStr }}</span></div>
                      <div class="infotd">
                        <span v-html="getLanguageHtml(orderData.roomNum,'roomNum')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('guest')}}</div>
                      <div class="infotd">
                        <span style="display: block; margin-bottom:5px" v-html="getLanguageHtml(orderData.person,'person')"></span>
                        <span style="display: block;" v-html="getLanguageHtml(orderData.child,'child')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('bedType')}}</div>
                      <div class="infotd">
                        <span v-html="getLanguageHtml(orderData.bedType,'bedType')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('breakfast')}}</div>
                      <div class="infotd" :class="{'greenText': orderData.breakfastCode === true}">
                        <span v-html="getLanguageHtml(orderData.breakfast,'breakfast')"></span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div class="titletd">{{$t('cancellationPolicy')}}</div>
                      <div class="infotd greenText" :class="{'redText': cancelData === 0}">
                        <span v-if="language === 'zh'">{{orderData.cancel.zh}}<span><img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="cancelDia = true"></span></span>
                        <span v-else>{{orderData.cancel.en}}
                                    <span v-if="orderData.cancel.endate !== ''"><br>{{orderData.cancel.endate}}</span>
                                    <span><img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="cancelDia = true"></span>
                                  </span>
                        <el-dialog :visible.sync="cancelDia" width="80%" :show-close="cancelShowClose" class="tax-margin" top="35vh">
                          <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">{{$t('cancellationPolicy')}}</div>
                          <div style="font-size: 12px; color: #303133; text-align: center; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                            <span v-if="language === 'zh'">{{canceltextZh}}</span>
                            <span v-else>{{canceltextEn}}</span>
                          </div>
                          <div @click="cancelDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div>
                        </el-dialog>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>
    <!--价格详情-->
    <el-skeleton animated :loading="orderShow">
      <template slot="template">
        <div class="msg-right">
          <div class="priceText"><el-skeleton-item variant="text" style="height: 25px; margin-top: 15px;width: 80px;"/></div>
          <div class="priceInfo">
            <div style="padding: 4.5% 4.5% 0;">
              <div class="jianye" style="height:50px; width: 100%;">
                <div style="float:left; width: 40%;">
                  <el-skeleton-item variant="text" style="display: block;margin-bottom: 8px;"/>
                  <el-skeleton-item variant="text" style="display: block;"/>
                </div>
                <div style="float:right; width: 30%;">
                  <el-skeleton-item variant="text" style="display: block;"/>
                </div>
              </div>
              <div class="mobile-price-detail-oneline">
                <div style="float:left; width: 40%;">
                  <el-skeleton-item variant="text"/>
                </div>
                <div style="float:right; width: 30%;">
                  <el-skeleton-item variant="text"/>
                </div>
              </div>
            </div>
          </div>
          <div style="clear:both; font-size:16px; font-weight:650; height: 54px; padding: 0px 4.5%; line-height: 54px;">
            <div style="display:inline-block;float:left;"><el-skeleton-item variant="text" style="height: 25px; margin-top: 15px;width: 80px;"/></div>
            <div style="display:inline-block;float:right;"><el-skeleton-item variant="text" style="height: 25px; margin-top: 15px;width: 80px;"/></div>
          </div>
        </div>
      </template>
      <template>
        <div class="msg-right" style="width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;">
          <div class="priceText">{{$t('priceDetails')}}</div>
          <div class="priceInfo">
            <div style="padding: 4.5% 4.5% 0;">
              <div class="jianye" style="height:50px;">
                <div style="float:left;" v-if="language === 'en'">
                  <span>{{orderData.roomCount}} {{$t('onOurSite')}}<span v-if="orderData.roomCount !=='1'">s</span> x {{orderData.nightCount}} {{$t('night')}}<span v-if="orderData.nightCount !== 1">s</span></span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" v-if="orderData.discount != ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} -{{orderData.discount}}</span>
                </div>
                <div style="float:left;" v-else>
                  <span>{{orderData.roomCount}}{{$t('onOurSite')}} x {{orderData.nightCount}}{{$t('night')}}</span><span class="avgprice">{{$t('avgNight')}} {{orderData.fare}}</span><span class="avgprice" style="color: #2f7000" v-if="orderData.discount != ''">{{$t('couponUseshortMsg')}} {{orderData.curMark}} -{{orderData.discount}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.fareTotal}}</span>
                </div>
              </div>
              <div class="mobile-price-detail-oneline">
                <div class="mobile-price-detail">
                  <span>{{$t('taxesFees')}}</span>
                  <span><img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="taxDia = true"></span>
                  <el-dialog :visible.sync="taxDia" width="80%" :show-close="taxShowClose" class="tax-margin" top="35vh">
                    <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">{{$t('taxesFees')}}</div>
                    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                    <div @click="taxDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div>
                  </el-dialog>
                </div>
                <div style="float:right;">
                  <span>{{orderData.tax}}</span>
                </div>
              </div>
              <!-- 交易费 开始 -->
              <div class="price-detail-twoline" v-if="TransactionFeeshow === true && source === 'sec'">
                <div style="float:left; height: 25px;">
                  <span>{{$t('TransactionFee')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.curMark}} <a v-if="orderData.discount != ''">{{discountFeeInfo[paymentOn]['discountTFee']}}</a><a v-else>{{transactionFeeInfo[paymentOn]['TFee']}}</a></span>
                </div>
              </div>
              <!-- 交易费 结束 -->
              <!-- commission -->
              <div class="mobile-price-detail-oneline" v-if="orderData.commission !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('commission')}}</span>
                  <span><img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="commissionDia = true"></span>
                  <el-dialog :visible.sync="commissionDia" width="80%" :show-close="taxShowClose" class="tax-margin" top="35vh">
                    <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">{{$t('commission')}}</div>
                    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('roompaiCommissionNotification')}}</div>
                    <div @click="commissionDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div>
                  </el-dialog>
                </div>
                <div style="float:right;">
                  <span>{{orderData.commission}}</span>
                </div>
              </div>
              <!-- payableAtProperty -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.mandatoryFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('mandatoryFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.mandatoryFee}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.mandatoryTax !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('mandatoryTax')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.mandatoryTax}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.resortFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('resortFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.resortFee}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.cityFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('cityTaxFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.cityFee}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.destinationFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('destinationFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.destinationFee}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.serviceFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('serviceFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.serviceFee}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.CleaningFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('cleaningFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.CleaningFee}}</span>
                </div>
              </div>
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.administrativeFee !== ''">
                <div class="mobile-price-detail">
                  <span>{{$t('administrativeFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.administrativeFee}}</span>
                </div>
              </div>
              <!-- 婴儿床费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.cribFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('cribFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.cribFee}}</span>
                </div>
              </div>
              <!-- 维护费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.maintenanceFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('maintenanceFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.maintenanceFee}}</span>
                </div>
              </div>
              <!-- 杂费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.miscellaneousFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('miscellaneousFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.miscellaneousFee}}</span>
                </div>
              </div>
              <!-- 其他费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.otherFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('otherFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.otherFee}}</span>
                </div>
              </div>
              <!-- 套餐费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.packageFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('packageFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.packageFee}}</span>
                </div>
              </div>
              <!-- 宠物卫生费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.petSanitationFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('petSanitationFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.petSanitationFee}}</span>
                </div>
              </div>
              <!-- 加床费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.rollawayFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('rollawayFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.rollawayFee}}</span>
                </div>
              </div>
              <!-- 客房服务费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.roomServiceFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('roomServiceFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.roomServiceFee}}</span>
                </div>
              </div>
              <!-- 附加费 -->
              <div :class="{'mobile-price-detail-twoline': payAtHotel === true, 'mobile-price-detail-oneline': payAtHotel === false}" v-if="orderData.surchargeFee !== ''">
                <div style="float:left; height: 25px;">
                  <span>{{$t('surchargeFee')}}</span>
                  <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                </div>
                <div style="float:right;">
                  <span>{{orderData.surchargeFee}}</span>
                </div>
              </div>
            </div>
          </div>
          <div :class="{'mobile-total-price-twoline': payAtHotel === true, 'mobile-total-price-oneline': payAtHotel === false}">
            <div style="display:inline-block;float:left;">
              <span style="display: block;line-height: 27px;">{{$t('totalPrice')}}</span>
              <span style="display: block;line-height: normal;font-weight: 100;color: #A9A9A9;font-size: 12px;" v-if="payAtHotel === true">Payable at property</span>
            </div>
            <div style="display:inline-block;float:right;line-height: 27px;" v-if="orderData.discount != ''">{{orderData.curMark}} <span v-if="TransactionFeeshow === true && source === 'sec'">{{discountFeeInfo[paymentOn]['discountTotalPrice']}}</span><span v-else>{{orderData.discountTotalPrice}}</span></div>
            <div style="display:inline-block;float:right;line-height: 27px;" v-else>{{orderData.curMark}} <a v-if="TransactionFeeshow === true && source === 'sec'">{{transactionFeeInfo[paymentOn]['totalPPrice']}}</a><a v-else>{{orderData.totalPrice}}</a></div>
          </div>
          <div style="clear: both;font-size: 14px;height: 20px;padding: 0px 4.5%;line-height: 20px;" v-if="orderData.payAtProperty !== '' && payAtHotel === true">
            <div style="display:inline-block;float:left;">{{$t('payNow')}}</div>
            <div style="display:inline-block;float:right;" v-if="orderData.discount != ''">{{orderData.curMark}} <span v-if="TransactionFeeshow === true && source === 'sec'">{{discountFeeInfo[paymentOn]['discountPayPrice']}}</span><span v-else>{{orderData.discountPayPrice}}</span></div>
            <div style="display:inline-block;float:right;" v-else>{{orderData.curMark}} <a v-if="TransactionFeeshow === true && source === 'sec'">{{transactionFeeInfo[paymentOn]['payPPrice']}}</a><a v-else>{{orderData.payPrice}}</a></div>
          </div>
          <div style="clear:both; font-size:14px; height: 54px; padding: 0px 4.5%; line-height: 54px;" v-if="orderData.payAtProperty !== '' && payAtHotel === true">
            <div style="display:inline-block;float:left;">{{$t('payableAtProperty')}}</div>
            <div style="display:inline-block;float:right;">{{orderData.payAtProperty}}</div>
          </div>
          <div style="clear: both;font-size: 14px; padding: 0px 4.5%;line-height: 15px;" v-if="source !== 'google' && orderData.payAtProperty === '' && orderData.hotelFeesEnText !== '' && payAtHotel === true">
            <div style="border-top: 2px dashed #ccc;padding-top: 10px;margin: 10px 0px 20px;">
              <div style="display: block;font-size: 12px;font-weight: 340;margin-bottom: 3px;">{{$t('notIncludedInTotal')}}</div>
              <div style="display: block;font-size: 12px;font-weight: 340;">
                {{$t('mandatoryChargeHotelCollected')}}
                <span style="color: #279BF3; text-decoration: unset; cursor: pointer;" @click="mandatoryFeeDetail = true">{{$t('details')}}</span>
                <el-dialog :visible.sync="mandatoryFeeDetail" width="80%" :show-close="taxShowClose" class="tax-margin" top="35vh">
                  <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">{{$t('mandatoryFee')}}</div>
                  <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"><p style="font-size:12px;" class="hotelFeesText" v-if="language === 'en'" v-html="orderData.hotelFeesEnText"></p><p style="font-size:12px;" class="hotelFeesText" v-if="language === 'zh'" v-html="orderData.hotelFeesZhText"></p></div>
                  <div @click="mandatoryFeeDetail = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div>
                </el-dialog>
              </div>
            </div>
          </div>
          <div v-if="orderData.discount != ''">
            <div class="coupon-info">
              <img src="/static/img/order/u207.png" class="coupon-img">
              <span style="margin-left: 5px">{{$t('couponUselargeMsg')}} {{orderData.curMark}} {{orderData.discount}}{{$t('point')}}</span>
            </div>
            <div style="margin: 8px 0px 10px 0px;font-size:12px;">
              <span class="coupon-text">{{$t('couponUseshortMsg')}} {{orderData.discountCode}}</span>
              <span v-if="nowPageData === 'bookingWriteOrder'">
                （<span style="color: rgb(83, 146, 249); cursor: pointer;" @click="delCoupon" >{{$t('remove')}}</span>）
              </span>
            </div>
          </div>
          <div style="clear: both;font-size: 12px;font-weight: 340;padding: 0px 4.5%;height: 10px;" v-if="orderData.payAtProperty !== '' && payAtHotel === true">
            <div style="display:inline-block;float:left;padding-bottom: 15px;">{{$t('priceDetailMsg')}}</div>
          </div>
<!--          <div style="clear: both;font-size: 12px;font-weight: 340;padding: 0px 4.5%;height: 10px;" v-if="orderData.payAtProperty !== ''">-->
<!--            <div style="display:inline-block;float:left;padding-bottom: 15px;">{{$t('priceDetailMsg')}}</div>-->
<!--          </div>-->
        </div>
      </template>
    </el-skeleton>
  </div>
</el-container>
</template>

<script>
export default {
  name: 'OrderRight',
  props: ['hotelOut', 'orderDataOut', 'source', 'language', 'ismobile', 'nowPageData', 'TransactionFeeshowOut', 'paymentOn'],
  components: {},
  data () {
    return {
      hotel: {},
      orderData: {'roomName': {'zh': '', 'en': ''}, 'cancel': {'zh': '', 'en': ''}, 'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'mandatoryFee': '', 'mandatoryTax': '', 'resortFee': '', 'payAtProperty': '', 'commission': '', 'hotelFeesEnText': '', 'cityFee': '', 'destinationFee': '', 'serviceFee': '', 'CleaningFee': '', 'administrativeFee': '', 'roomCount': '', 'nightCount': '', 'tax': ''},
      dateNumComplexStr: '',
      roomNumComplexStr: '',
      cancelData: 0,
      canceltextZh: '',
      canceltextEn: '',
      taxDia: false,
      cancelShowClose: false,
      taxShowClose: false,
      cancelDia: false,
      commissionDia: false,
      mandatoryFeeDetail: false,
      hotelShow: true,
      orderShow: true,
      TransactionFeeshow: false,
      transactionFeeInfo: {},
      discountFeeInfo: {},
      payAtHotel: true
    }
  },
  watch: {
    hotelOut: function (hotel) {
      console.log(hotel)
      this.hotel = hotel
      this.hotelShow = false
      this.orderShow = false
    },
    orderDataOut: function (orderData) {
      this.orderData = orderData
      this.transactionFeeInfo = this.orderData.transactionFeeInfo
      this.discountFeeInfo = this.orderData.discountTFeeInfo
      this.cancelData = orderData.cancelData.en
      this.canceltextZh = orderData.canceltext.zh
      this.canceltextEn = orderData.canceltext.en
      this.payAtHotel = this.orderData.payAtHotel
      // 判断夜是否大于1
      if (this.language === 'en' && orderData.night.en > 1) {
        this.dateNumComplexStr = 's'
      } else {
        this.dateNumComplexStr = ''
      }
      // 判断房间是否大于1
      if (this.language === 'en' && orderData.roomNum.en > 1) {
        this.roomNumComplexStr = 's'
      } else {
        this.roomNumComplexStr = ''
      }
      this.orderShow = false
    },
    TransactionFeeshowOut: function (val) {
      console.log('数据变更支付方式：' + val)
      this.TransactionFeeshow = val
    }
  },
  created () {},
  mounted () {},
  methods: {
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData'].includes(type)) {
        if (getLanguage === 'zh') {
          if (type === 'roomName' && (data.zh === '' || data.zh === null)) {
            return data.en
          }
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'emailError', 'telError', 'emailConfirmError'].includes(type)) {
        return this.$t(data)
      } else if (['buttonMeansYouAgree'].includes(type)) {
        return this.$t(type)
      }
    },
    delCoupon: function () {
      this.orderData.discount = ''
      var couponInfo = {'discountPrice': '', 'userCouponId': '', 'couponId': ''}
      this.$emit('getCouponInfo', couponInfo)
    }
  },
  computed: {}
}
</script>

<style scoped>
/* 右侧部分 */
.msg-right-all{width:352px; float: right;}
.msg-right{width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
/* 评分 */
.score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
.scoreNo{height: 6px;border-radius: 0px 4px 4px 0px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
.scoreYes{height: 100%;border-radius: 0px;text-align: right;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
/* 预订信息 */
.advanceText{font-size:18px; font-weight:650; border-bottom: 1px solid rgba(221, 223, 226, 1);height: 54px; line-height: 54px; padding:0px 4.5%;}
.advanceInfo{ margin-top:13px;color:#333333;padding: 0px 4.5%;}
.titletd{ width:35%; font-size:14px; font-weight:650; display:inline-block;vertical-align: top;color:#333333;}
.infotd{ width: 60%;display: inline-block;color:#333333;}
.advanceInfo td{ padding-bottom:12px;}
.greenText{color:#2F7000;}

.redText{color:#E12D2D;}
/* 价格详情 */
.msg-price{width:28%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
.priceText{font-size:18px; font-weight:650;height: 54px;padding: 0px 4.5%; line-height: 54px;}
.priceInfo{background-color:rgba(221, 223, 226, 0.2980392156862745); height:auto; font-size:14px;color:#333333;}
.avgprice{display:block;color:#616161;font-size:12px;}
.jianye div{margin-bottom: 20px;}
.jianye span{margin-top:5px;}
.popverText{ font-size:12px;width:20%;}
.price-detail-twoline{clear:both; height:50px;padding-top: 10px;}
.price-detail-oneline{clear:both; height:30px;padding-top: 10px;}
.mobile-price-detail{float:left; height: 19px;line-height: 19px; vertical-align: middle;}
.mobile-price-detail-twoline{clear:both;height:50px;}
.mobile-price-detail-oneline{clear:both;height:30px;}
.mobile-total-price-twoline{clear:both; font-size:16px; font-weight:650; height: 54px; padding: 0px 4.5%; line-height: 54px;}
.mobile-total-price-oneline{clear:both; font-size:16px; font-weight:650; height: 34px; padding: 0px 4.5%; line-height: 54px;}

/* 优惠券信息 */
.coupon-info{min-height: 22px;font-size:12px; padding: 0 5px; border-radius: 5px;background-color: #d2e6c8;box-sizing: border-box;color: #2f7000;text-align: left;line-height: normal;margin: 0px 4.5%;font-size: 12px;line-height: 22px; display: flex;align-items: center;}
.coupon-text{color: #2f7000;text-align: left;font-size: 12px;padding: 0 2.5% 0 4.5%;}
.coupon-img{width:20px; height:20px;line-height: 22px;vertical-align: middle;}
.coupon-info img{vertical-align: middle;}
/* 住房须知 */
.hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}

@media screen and (min-width: 1201px) {
.main{width:1100px;}
}
@media only screen and (min-width:1001px) and (max-width:1200px){
.main {width:95%;}
}
@media screen and (max-width: 1000px) {
.main {width:100%; margin: 0;}
.msg-right-all,.msg-left{clear:both; width:100%;margin:0px;}
.orange-text div{display: inline-block !important;}
.tax-dia .el-dialog__body{padding: 0px 15px 15px 15px !important;}
.tax-margin /deep/ .el-dialog{display: flex;flex-direction: column;margin:0 !important;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
.tax-margin /deep/ .el-dialog .el-dialog__body{flex:1; overflow: auto;}
.advanceText, .priceText{ font-size: 16px;}
}
</style>



// WEBPACK FOOTER //
// src/components/order/module/OrderRight.vue